import { ACTIONS } from '_redux/actions';

const initialState = {
  keys: {},
  isLoading: false,
};

export default function translations(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.TRANSLATIONS.FETCH_TRANSLATIONS: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case ACTIONS.TRANSLATIONS.FETCH_TRANSLATIONS_SUCCESS: {
      return {
        ...state,
        keys: {
          ...action.payload.data.localisations,
        },
        isLoading: false,
      };
    }

    default:
      return state;
  }
}
